// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Space, Select, Text } from '@mantine/core';
import { useContext } from 'react';
import { i18n } from '@lingui/core';
import { openModal } from '@mantine/modals';
import AvailabilityIcon from '../../Atoms/AvailabilityIcon';
import AvailableCheck from '../../Molecules/AvailableCheck';
import PanePaper from '../../Molecules/PanePaper';
import { EventContext } from '../../Service/Context/EventContext';
import { DataS } from '../../Service/DataS';
import BookingEvent from '../../Types/Event';
import BookingState from '../../Types/Enums/BookingState';
import ChangeRecommendedEventStateModal from './ChangeRecommendedEventStateModal';

const AvailabilityPane = () => {
  const { event, saveEvent } = useContext<any>(EventContext);
  const { recommendationId, bookingState } = event as BookingEvent;

  const changeBookingState = (_bookingState: BookingState) => {
    if (recommendationId) {
      const currentState = i18n._(`recommendation.bookingState.${bookingState.toLowerCase()}`);
      const newState = i18n._(`recommendation.bookingState.${_bookingState.toLowerCase()}`);
      openModal({
        title: (
          <Text mt="md" size="xl" sx={{ lineHeight: 1.2 }}>
            Statusänderung von{' '}
            <Text span weight="bolder">
              {currentState}
            </Text>{' '}
            auf{' '}
            <Text span weight="bolder">
              {newState}
            </Text>
          </Text>
        ),
        closeOnEscape: true,
        transition: 'slide-down',
        children: (
          <ChangeRecommendedEventStateModal
            recommendationId={recommendationId}
            newBookingState={_bookingState}
            onFinish={() => saveEvent({ bookingState: _bookingState })}
          />
        ),
      });
    } else {
      saveEvent({ bookingState: _bookingState });
    }
  };

  return (
    <PanePaper title="Verfügbarkeit">
      <AvailableCheck dates={event.dates} eventId={event.id} />
      <Space h="xs" />
      <Text size="xs" color="dimmed">
        Event status
      </Text>
      <Select
        value={event.bookingState}
        data={DataS.getBookingStateOptions(recommendationId)}
        onChange={(state) => changeBookingState(state as BookingState)}
        icon={<AvailabilityIcon bookingState={event.bookingState} />}
      />
    </PanePaper>
  );
};

export default AvailabilityPane;
